import React, { useContext, useState, useEffect } from "react";
import { GlobalState } from "../Helper/Context";
import axios from "axios";
import DownArrow from "../Assets/Icon/DownArrow";
import VerseTranslate from "../Helper/VerseTranslate";
import Reader from "../Components/Reader";
import VerseReader from "../Helper/VerseReader";
import VersePlayer from "../Components/VersePlayer";
import MarkIcon from "../Assets/Icon/MarkIcon";
const Memorization = ({ title }) => {
  const [allSurah, setAllSurah] = useState([]);
  const { state, setState } = useContext(GlobalState);
  // store surah verse nmber 1 ,2 ,3 ......
  const [verseNumber, setVerseNumber] = useState([]);
  // store verse data (text , and audio file from api)
  const [verse, setVerse] = useState({});
  // get vrese translate and store here
  const [verseTranslateText, setVerseTranslateText] = useState({});
  const [showDrobList, setShowDrobList] = useState({
    surah: false,
    verse: false,
    translate: false,
  });
  document.title = title;
  useEffect(() => {
    //fetch surah name
    axios
      .get("https://api.alquran.cloud/v1/surah")
      .then((res) => setAllSurah(res.data.data));
  }, []);
  useEffect(() => {
    // get verse translate request
    axios
      .get(
        `https://api.alquran.cloud/v1/ayah/${state.selectedMemorizationSurah.number}:${state.selectedVerse}/${state.TranslateVerse.identifier}`
      )
      .then((res) => setVerseTranslateText(res.data.data));
    // get verse text request
    axios
      .get(
        `https://api.alquran.cloud/v1/ayah/${state.selectedMemorizationSurah.number}:${state.selectedVerse}/${state.selectedVerseReader.identifier}`
      )
      .then((res) => setVerse({ ...verse, ...res.data.data }));

    // made list verse number
    const updatedNumbers = [];
    for (let i = 1; i <= state.selectedMemorizationSurah.numberOfAyahs; i++) {
      updatedNumbers.push(i);
    }
    setVerseNumber(updatedNumbers);
  }, [
    state.selectedMemorizationSurah.numberOfAyahs,
    state.selectedVerse,
    state.TranslateVerse,
    state.selectedVerseReader,
  ]);
  return (
    <section className="flex flex-col md:flex-row flex-wrap gap-4 relative container m-auto pb-8 px-4">
      <Reader verseReader={VerseReader} />
      <main className="h-full max-w-full md:w-[calc(100%-300px)] relative bg-[#F5F7F9] flex-1 rounded-[45px] px-8 py-20">
        <h2 className=" text-[var(--MColor)] text-center text-3xl">
          {state.langTo === "EN"
            ? "قسم التحفيظ الذاتي"
            : "Self-Memorization Section"}
        </h2>
        <ul className="mt-4 flex justify-center gap-5 text-sm whitespace-nowrap flex-wrap">
          <li
            className=" inline-flex items-center justify-between gap-2 bg-[#FBFCFD] p-2 rounded-lg cursor-pointer relative w-36 "
            onClick={() =>
              setShowDrobList({
                surah: !showDrobList.surah,
                verse: false,
                translate: false,
              })
            }
          >
            {state.langTo === "EN"
              ? state.selectedMemorizationSurah.name
                  .replace(/[\u064B-\u065F|\u06E1]/g, "")
                  .replaceAll("ٱ", "ا")
                  .replaceAll("ىٰ", "ى")
                  .replaceAll("مٰ", "م")
              : state.selectedMemorizationSurah.englishName}
            <DownArrow />
            <ul
              className={` z-10 absolute max-h-[70vh] overflow-auto top-10 right-0 bg-white p-2 w-36 shadow-sm rounded-b-lg transition-all ${
                showDrobList.surah
                  ? "top-10 opacity-1 pointer-events-auto"
                  : "top-40 opacity-0 pointer-events-none"
              }`}
            >
              {allSurah.map((surah) => (
                <li
                  key={surah.number}
                  onClick={() => {
                    localStorage.setItem(
                      "selectedMemorizationSurah",
                      JSON.stringify(surah)
                    );
                    localStorage.setItem("selectedVerse", 1);
                    setState({
                      ...state,
                      selectedMemorizationSurah: surah,
                      selectedVerse: 1,
                    });
                  }}
                  className={`mb-4 ${
                    state.selectedMemorizationSurah.number === surah.number &&
                    "text-[var(--MColor)]"
                  } `}
                >
                  {state.langTo === "EN"
                    ? surah.name
                        .replace(/[\u064B-\u065F|\u06E1]/g, "")
                        .replaceAll("ٱ", "ا")
                        .replaceAll("ىٰ", "ى")
                        .replaceAll("مٰ", "م")
                    : surah.englishName}
                </li>
              ))}
            </ul>
          </li>
          <li
            className="inline-flex items-center justify-between gap-2 bg-[#FBFCFD] p-2 rounded-lg cursor-pointer w-28 relative"
            onClick={() =>
              setShowDrobList({
                surah: false,
                verse: !showDrobList.verse,
                translate: false,
              })
            }
          >
            {state.langTo === "EN" ? "الآية " : "Verse "}
            {state.selectedVerse}
            <DownArrow />
            <ul
              className={` z-10 absolute max-h-[70vh] overflow-auto right-0 bg-white p-2 w-28 shadow-sm rounded-b-lg transition-all ${
                showDrobList.verse
                  ? "top-10 opacity-1 pointer-events-auto"
                  : "top-40 opacity-0 pointer-events-none"
              }`}
            >
              {verseNumber.map((number) => (
                <li
                  onClick={() => {
                    localStorage.setItem("selectedVerse", number);
                    setState({
                      ...state,
                      selectedVerse: number,
                    });
                  }}
                  key={number}
                  className={`mb-4 ${
                    state.selectedVerse == number
                      ? "text-[var(--MColor)]"
                      : null
                  }`}
                >
                  {number}
                </li>
              ))}
            </ul>
          </li>
          <li
            className="inline-flex items-center justify-between gap-2 bg-[#FBFCFD] p-2 rounded-lg cursor-pointer min-w-[160px] relative"
            onClick={() =>
              setShowDrobList({
                surah: false,
                verse: false,
                translate: !showDrobList.translate,
              })
            }
          >
            {state.langTo === "EN"
              ? "ترجمة " + state.TranslateVerse.langName
              : "Translate to " + state.TranslateVerse.EnglishLangName}
            <DownArrow />
            <ul
              className={` z-10 absolute max-h-[70vh] overflow-auto top-10 right-0 bg-white p-2 w-40 shadow-sm rounded-b-lg transition-all ${
                showDrobList.translate
                  ? "top-10 opacity-1 pointer-events-auto"
                  : "top-40 opacity-0 pointer-events-none"
              }`}
            >
              {VerseTranslate.map((item) => (
                <li
                  onClick={() => {
                    localStorage.setItem(
                      "TranslateVerse",
                      JSON.stringify(item)
                    );
                    setState({ ...state, TranslateVerse: item });
                  }}
                  key={item.identifier}
                  className={`mb-4 ${
                    state.TranslateVerse.identifier == item.identifier
                      ? "text-[var(--MColor)]"
                      : null
                  }`}
                >
                  {state.langTo === "EN" ? item.langName : item.EnglishLangName}
                </li>
              ))}
            </ul>
          </li>
        </ul>
        <div className="text-center mt-20 font-bold">
          <p className=" font-serif text-2xl">{verse.text}</p>
          <p className=" text-2xl mt-10 [direction:ltr]">
            {verseTranslateText.text}
          </p>
        </div>
        <div
          className="goToMark cursor-pointer bg-[var(--MColor)] text-white gap-2 px-2 py-1 flex items-center absolute left-8 top-8 rounded-xl"
          onClick={() => {
            if (state.markVerse !== "") {
              localStorage.selectedMemorizationSurah = JSON.stringify(
                JSON.parse(state.markVerse).surah
              );
              localStorage.selectedVerse = JSON.parse(
                state.markVerse
              ).numberInSurah;
              setState({
                ...state,
                selectedMemorizationSurah: JSON.parse(state.markVerse).surah,
                selectedVerse: JSON.parse(state.markVerse).numberInSurah,
              });
            } else {
              state.langTo === "EN"
                ? alert("يبدو أنك لم تقم بوضع علامة على اي آية")
                : alert("Looks like you haven't marked any verse");
            }
          }}
        >
          <MarkIcon />
          {state.langTo === "EN" ? "انتقل للعلامة" : "Go to mark"}
        </div>
        <VersePlayer
          src={verse.audio}
          verse={verse}
          state={state}
          setState={setState}
        />
      </main>
    </section>
  );
};

export default Memorization;
